// extracted by mini-css-extract-plugin
export var aircallIframe = "_ff-3";
export var fabContainer = "_ff-5";
export var fabRinging = "_ff-6";
export var loadingOverlay = "_ff-4";
export var pulse = "_ff-7";
export var widgetContent = "_ff-2";
export var widgetPanel = "_ff-0";
export var widgetPanelExpanded = "_ff-1";